import React, { PropsWithChildren } from "react";
import { Grid } from "@mui/material";
//#region types
import { GridRProps } from "models/propTypes/commonPropTypes";
import cssExports from "theme/styles/main.module.scss";
//#endregion

const GridR: React.FC<PropsWithChildren<GridRProps>> = (props) => {
  return (
    <Grid
      id={props.id}
      classes={{
        ...props.classes,
        root: cssExports.gridRoot,
        "spacing-xs-1": cssExports.spacing_1,
        "spacing-xs-2": cssExports.spacing_2,
        "spacing-xs-3": cssExports.spacing_3,
        "spacing-xs-4": cssExports.spacing_4,
        "spacing-xs-5": cssExports.spacing_5,
        "spacing-xs-6": cssExports.spacing_6,
        "spacing-xs-7": cssExports.spacing_7,
        "spacing-xs-8": cssExports.spacing_8,
        "spacing-xs-9": cssExports.spacing_9,
        "spacing-xs-10": cssExports.spacing_10,
      }}
      style={props.style}
      className={props.className}
      container={props.container}
      item={props.item}
      direction={props.direction}
      justifyContent={props.justifyContent}
      alignContent={props.alignContent}
      alignItems={props.alignItems}
      xl={props.xl}
      lg={props.lg}
      md={props.md}
      sm={props.sm}
      xs={props.xs}
      spacing={props.spacing}
      wrap={props.wrap}
      zeroMinWidth={props.zeroMinWidth}
      hidden={props.hidden}
    >
      {props.children}
    </Grid>
  );
};

export default GridR;
